import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link,ReferenceOneField, TextField } from 'react-admin';
import AvatarField from './AvatarField';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'center',
    },
    avatar: {
        marginRight: theme.spacing(1),
    },
}));


const TUserField = ({ record, size }) => {
    const classes = useStyles();
    return record ? (
        <div className={classes.root}>
            <AvatarField
                className={classes.avatar}
                record={record}
                size={size}
            />
            <Link to={`/users/${record.user_id}/`} >{record.user_name}</Link>
        </div>
    ) : null;
};

export default TUserField;
